"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query getVideo($videoId: String!) {\n    getVideo(videoId: $videoId) {\n      videoId\n      organisationId\n      createdByUserId\n      assetIds\n      name\n      outputs {\n        completedAt\n        videoId\n        outputId\n        isMaster\n        assignedEditorId\n        name\n        aspectRatio\n        latestVersion\n        inspirationId\n        versions {\n          versionId\n          outputId\n          assetId\n          versionNumber\n        }\n      }\n    }\n    getProjectForVideo(videoId: $videoId) {\n      videoProjectId\n      name\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getVideoQuery = (0, _graphqlTag.default)(_templateObject());

var getVideo = function getVideo(videoId) {
  return {
    query: getVideoQuery,
    module: 'video',
    ignoreCache: true,
    buildVariables: function buildVariables() {
      return {
        videoId: videoId
      };
    }
  };
};

var _default = getVideo;
exports.default = _default;